import { render, staticRenderFns } from "./EditTrainingCenter.vue?vue&type=template&id=4c64ec91&scoped=true&"
import script from "./EditTrainingCenter.vue?vue&type=script&lang=js&"
export * from "./EditTrainingCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c64ec91",
  null
  
)

export default component.exports